import { render } from "./recorder.vue?vue&type=template&id=fcc832b0"
import script from "./recorder.vue?vue&type=script&lang=js"
export * from "./recorder.vue?vue&type=script&lang=js"

import "./recorder.vue?vue&type=style&index=0&id=fcc832b0&lang=scss"

import exportComponent from "C:\\xampp\\htdocs\\projects\\external\\kazigraphix\\admin.kazigraphix\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__